/// <amd-module name="Feed/Legacy/Protocols/UPack/UPackOverviewContentPanel" />
import * as React from "react";

import { IPackageDetailsProps } from "Feed/Legacy/Protocols/Common/IPackageDetailsProps";
import { CopyableTextField, ICopyableTextFieldTelemetry } from "Feed/Legacy/Protocols/Components/CopyableTextField";
import { PackageTile } from "Feed/Legacy/Protocols/Components/PackageTile";

import { CiConstants } from "Feed/Common/Constants/Constants";
import * as PackageResources from "Feed/Common/Resources";

export class UPackOverviewContentPanel extends React.Component<IPackageDetailsProps, {}> {
    public render(): JSX.Element {
        const { feed, packageSummary, packageVersion, protocol } = this.props;
        const textfieldId = "upack-overview-textfield-label1";

        const command = this.getDownloadCommand();
        const displayText = this.getDownloadCommand(" \\\n  ");

        return (
            <div className="package-overview-content-panel">
                {!this.props.packageVersion.isDeleted && (
                    <PackageTile title={PackageResources.UPack_InstallInstructions_Title} id={textfieldId}>
                        <CopyableTextField
                            pageContext={this.props.pageContext}
                            displayText={displayText}
                            text={command}
                            buttonAriaLabel={PackageResources.AriaLabel_CopyToClipBoard_Install_Copy}
                            textFieldAriaLabel={PackageResources.AriaLabel_CopyToClipBoard_UPack_Command}
                            telemetryProperties={
                                {
                                    commandName: CiConstants.CopyCommandInstall,
                                    feedName: feed.name,
                                    packageName: packageSummary.name,
                                    packageVersion: packageVersion.version,
                                    protocol: protocol.name
                                } as ICopyableTextFieldTelemetry
                            }
                            ariaDescribedByIdForLabelText={textfieldId}
                        />
                    </PackageTile>
                )}
                <PackageTile title={PackageResources.NuGet_Description_Title}>
                    <div className="package-description">{this.props.packageVersion.description}</div>
                </PackageTile>
            </div>
        );
    }

    private getDownloadCommand(separator: string = " "): string {
        return this.props.protocol.getCopyInstallCommand(
            this.props.feed,
            this.props.packageSummary.name,
            this.props.packageVersion,
            separator
        );
    }
}
